import { MutationTree } from 'vuex';
import { State } from './state';
import { KpiMutationTypes } from './mutation-types';
import { KpiTableAndChart } from '@/types/KPI';
import { KpiGroupedApiResponse } from './types';
import { clone, findIndex } from 'lodash';

export type Mutations<S = State> = {
  [KpiMutationTypes.SET_KPI_DATA](
    state: S,
    payload: { kpiData: KpiTableAndChart }
  ): void;
  [KpiMutationTypes.SET_KPI_DATA_LOADING](state: S, isLoading: boolean): void;
  [KpiMutationTypes.SET_GROUPED_KPI_DATA](
    state: S,
    payload: Array<KpiGroupedApiResponse>
  ): void;
  [KpiMutationTypes.SET_GROUPED_KPI_DATA_LOADING](
    state: S,
    isLoading: boolean
  ): void;
  [KpiMutationTypes.CLEAR_KPI_DATA](state: S): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [KpiMutationTypes.SET_KPI_DATA](
    state: State,
    payload: {
      kpiData: KpiTableAndChart;
    }
  ) {
    const newKpiData = clone(state.kpiData);
    const existingIndex = findIndex(state.kpiData, {
      aggregateFieldType: payload.kpiData.aggregateFieldType,
    });
    if (existingIndex > -1) {
      newKpiData.splice(existingIndex, 1);
    }
    newKpiData.push(payload.kpiData);
    state.kpiData = newKpiData;
  },
  [KpiMutationTypes.SET_KPI_DATA_LOADING](state: State, isLoading: boolean) {
    state.kpiDataIsLoading = isLoading;
  },
  [KpiMutationTypes.SET_GROUPED_KPI_DATA](
    state: State,
    payload: Array<KpiGroupedApiResponse>
  ) {
    state.groupedKpiData = payload;
  },
  [KpiMutationTypes.SET_GROUPED_KPI_DATA_LOADING](
    state: State,
    isLoading: boolean
  ) {
    state.groupedKpiDataIsLoading = isLoading;
  },
  [KpiMutationTypes.CLEAR_KPI_DATA](state: State) {
    state.kpiData = [];
    state.groupedKpiData = null;
  },
};
